var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKapcsolatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 40,
    viewBox: "0 0 21 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V40H0V0Z",
    fill: "#7C6CC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 4.63037H17.3896V33.8201H3.59961V4.63037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKapcsolatIcon);
export default __webpack_public_path__ + "static/media/KapcsolatIcon.7aca48d9b93b793df6541692c69d4c04.svg";
export { ForwardRef as ReactComponent };